export class WorkflowTicket {
    public id: number;
    public flow_id: number;
    public trackingId: string;
    public level: number;
    public stage: number;
    public sub_level: number;
    public approval_from: string;
    public approval_name: string;
    public approved_by: string;
    public comments: string;
    public status: string;
    public doc_id: string;
    public pending_from_dt: Date;
    public approved_dt: Date;
    public created_dt: Date;
    public created_by: string;
    public update_dt: Date;
    public updated_by: string;
    public flowName: string;
    public isStausPending: boolean;
    public approval_type: string;
    public final_status: string;
    public message_content: string;
    public submitted_by: string;
    public comment: string;
    public cust: string;
    public customerName: string;
    public corp: string;
    public house: string;
    public compasid: string;
    public revenue: string;
    public wordate: string;
    public wfindate: string;
    public message: string;
    public cdt: any;
    public pdt: Date;
    public apdt: Date;
    public loggedinrole: string;
    public kpiid: string;
    public isValueDisabled: boolean = false;
    public finalizeddate: string;
    public accnumber: string;
    public disputeType: string;
    public chargeback_delete_id: any;
    public complanid: any;
    public complex_kpiid: any;
    public salesRepId: string;
    public empName: string;
    public sales_channel: string;
    public totalCommission: number;
    public payrollMonth: string;

    public accnum: any;
    public calRunId: any;
    public comm_plan_id: any;
    public employee_id: any;
    public kom_feed_id: any;
    public loggedin_role: any;

    public mob_feed_id: any;
    public recordType: any;
    public sales_rep_id: any;
    public sc_emp_id: any;
    public tracking_id: any;
    public workflow_name: any;

    public pendingdt: Date;
    public approveddt: Date;
    public compasID: any;
    public submittedDate: any;
    public submittedBy:any;

    constructor() {
        this.submittedBy = null;
        this.submittedDate = null;
        this.compasID = null;
        this.pendingdt = null;
        this.approveddt = null;

        this.accnum = null;
        this.calRunId = null;
        this.comm_plan_id = null;
        this.employee_id = null;
        this.kom_feed_id = null;
        this.loggedin_role = null;

        this.mob_feed_id = null;
        this.recordType = null;
        this.sales_rep_id = null;
        this.sc_emp_id = null;
        this.tracking_id = null;
        this.workflow_name = null;

        this.sales_channel = null;
        this.totalCommission = null;
        this.payrollMonth = null;
        this.salesRepId = null;
        this.empName = null;
        this.complex_kpiid = null;
        this.complanid = null;
        this.chargeback_delete_id = null;
        this.disputeType = null;
        this.accnumber = null;
        this.finalizeddate = null;
        this.isValueDisabled = false;
        this.kpiid = null;
        this.loggedinrole = null;
        this.cdt = null;
        this.pdt = null;
        this.apdt = null;
        this.customerName = null;
        this.corp = null;
        this.house = null;
        this.compasid = null;
        this.revenue = null;
        this.wordate = null;
        this.wfindate = null;
        this.id = null;
        this.flow_id = null;
        this.trackingId = null
        this.level = null;
        this.stage = null;
        this.sub_level = null;
        this.approval_from = null;
        this.approved_by = null;
        this.comments = null;
        this.status = null;
        this.doc_id = null;
        this.approved_dt = null;
        this.created_dt = null;
        this.created_by = null;
        this.update_dt = null;
        this.updated_by = null;
        this.pending_from_dt = null;
        this.flowName = null;
        this.isStausPending = false;
        this.approval_type = null;
        this.final_status = null;
        this.message_content = null;
        this.approval_name = null;
        this.submitted_by = null;
        this.comment = null;
        this.message = null;
    }
}
